import React, { useRef } from 'react'
import { Form, Input, Button, Flex } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import type { FlowStep, FlowStepInput } from '@/data'

interface VerificationEditorProps {
  step: FlowStep
  onChange: (step: FlowStep) => void
}

export const VerificationEditor: React.FC<VerificationEditorProps> = ({
  step,
  onChange,
}) => {
  const idCounter = useRef(0)
  const checks = step.inputs.filter((i) => i.type === 'text')

  const updateCheck = (index: number, value: string) => {
    const updatedChecks = checks.map((c, i) =>
      i === index ? { ...c, label: value } : c,
    )
    onChange({ ...step, inputs: updatedChecks })
  }

  const addCheck = () => {
    const newCheck: FlowStepInput = {
      id: `check_${++idCounter.current}`,
      label: 'New check item',
      type: 'text',
      placeholder: null,
      required: false,
    }
    onChange({ ...step, inputs: [...checks, newCheck] })
  }

  const removeCheck = (index: number) => {
    onChange({ ...step, inputs: checks.filter((_, i) => i !== index) })
  }

  return (
    <Form layout="vertical" size="small">
      <Form.Item label="Headline">
        <Input
          value={step.headline}
          onChange={(e) => onChange({ ...step, headline: e.target.value })}
          placeholder="Enter headline"
        />
      </Form.Item>

      <Form.Item label="Sub Headline">
        <Input
          value={step.sub_headline}
          onChange={(e) => onChange({ ...step, sub_headline: e.target.value })}
          placeholder="Enter sub headline"
        />
      </Form.Item>

      <Form.Item label="Check Items">
        <Flex vertical gap="small">
          {checks.map((check, index) => (
            <Flex key={check.id} gap="small" align="center">
              <Input
                value={check.label}
                onChange={(e) => updateCheck(index, e.target.value)}
                placeholder="Check item text"
              />
              {checks.length > 1 && (
                <Button
                  type="text"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => removeCheck(index)}
                />
              )}
            </Flex>
          ))}
          <Button
            type="dashed"
            size="small"
            icon={<PlusOutlined />}
            onClick={addCheck}
          >
            Add Check
          </Button>
        </Flex>
      </Form.Item>
    </Form>
  )
}
